/**
 * Shared styling for an editable date segment (used by StandardDateField and
 * StandardDateRangePicker). Focused segment uses a light-blue selection with
 * dark text (AAA contrast); the compound focused+placeholder variant forces
 * dark text on a focused placeholder, beating the lower-specificity placeholder grey.
 */
export const dateSegmentClasses = [
  "rounded px-0.5 text-base/6 text-neutral-900 tabular-nums caret-transparent outline-none",
  "data-[placeholder]:text-neutral-400",
  "data-[type=literal]:px-0 data-[type=literal]:text-neutral-400",
  "data-[focused]:bg-blue-200 data-[focused]:text-neutral-900",
  "data-[focused]:data-[placeholder]:text-neutral-900",
  "data-[disabled]:text-neutral-400",
];

/** The same segment styling as a single class string, for plain `className` props. */
export const dateSegmentClassName = dateSegmentClasses.join(" ");
